import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { filledToggleGroupSx } from "@shared";

import { EdictSource } from "@/api";
import { useTranslation } from "@/translations";

interface Props {
  value: EdictSource;
  onChange: (value: EdictSource) => void;
}

export function EdictSourceToggle({ value, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      exclusive
      value={value}
      aria-label={t("edicts.filter.sourceToggleAriaLabel")}
      onChange={(_event, next: EdictSource | null) => {
        if (next !== null) {
          onChange(next);
        }
      }}
      sx={filledToggleGroupSx}
    >
      <ToggleButton value={EdictSource.Edikt} sx={{ minWidth: 90 }}>
        {t("edicts.source.edikte")}
      </ToggleButton>
      <ToggleButton value={EdictSource.Ozufs} sx={{ minWidth: 90 }}>
        {t("edicts.source.ozufs")}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
